var path = 'app/components/common/footer/footer.html';
var html = "<div class=\"footer\"><div><strong>Copyright</strong> <a href=\"http://www.invita.hr\" target=\"_blank\">InVita d.o.o.</a> &copy; 2016.</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/footer/footer.html
// module id = 71
// module chunks = 0